import React, { Component } from 'react';
import styled from 'styled-components';
import FlipMove from 'react-flip-move';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import WP from 'WP';
import Container from 'partials/Container';
import api from 'api';
import HeadMeta from 'partials/HeadMeta';
import Post from 'partials/Post';
import Loader from 'partials/Loader';

import { setCurrentView } from 'store';

class Tours extends Component {

    constructor() {
        super();

        this.state = {
            posts: [],
        }
    }

    componentWillMount() {
        this.mounted = true;

        this.props.setCurrentView({
            translation_paths: {
                no: '/'+WP.slugs.tours.no,
                en: '/'+WP.slugs.tours.en
            }
        });

        api.getTours({ limit: 12 })
            .then(resp => {
                if(resp.data[0]) {
                    //console.log('NEWS: ', resp.data);
                    if(this.mounted) this.setState({ posts: resp.data });
                }
            })
            .catch(e => console.log(e));
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    _renderPosts() {
        return this.state.posts.map(post => <Post key={post.id} post={post} /> );
    }

    render() {
        return (
            <Wrapper>

                <HeadMeta
                    title={WP.trans.tours+' - HLM'}
                    description=""
                    ogUrl=""
                    ogType=""
                    ogTitle=""
                    ogDescription=""
                    ogImage=""
                />

                <Loader loaded={this.state.posts.length > 0} />
                
                <GridWrapper>
                    <Container>
                        <Grid 
                            duration={500} 
                            easing="ease-out"
                            enterAnimation={{
                                from: {
                                    transform: 'translateY(100px)',
                                    opacity: 0.1,
                                },
                                to: {
                                    transform: '',
                                },
                            }}
                            leaveAnimation={{
                                from: {
                                    transform: '',
                                },
                                to: {
                                    transform: 'translateY(100px)',
                                    opacity: 0.1,
                                },
                            }}
                        >
                            {this._renderPosts.bind(this)()}
                        </Grid>
                    </Container>
                </GridWrapper>

            </Wrapper>
        );
    }
}

const actions = {
    setCurrentView
}

export default connect(null, actions)(withRouter(Tours));

const Wrapper = styled.div`
    display:block;
    position:relative;
    width:100%;
`

const GridWrapper = styled.div`
    padding-top:30px;
    @media (max-width: 960px) {
        padding-top:0;
    }
`

const Grid = styled(FlipMove)`
    display:flex;
    flex-wrap: wrap;
    //overflow: hidden;
    flex-direction:column;
    position:relative;
    @media (max-width: 768px) {
        overflow: visible;
        display:block;
    }
`


// WEBPACK FOOTER //
// ./src/views/Tours.js